import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen, useQuery } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import { useBusinessRoleManageAccess, useTargetPerson } from 'hooks'
import BusinessRoleDetails from './BusinessRoleDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const BusinessRolesDrawer = ({ attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const [targetPerson] = useTargetPerson()

    const query = useQuery()

    const assignmentId = query.get('selected')

    const { data: businessRole } = useBusinessRoleManageAccess(
        assignmentId,
        targetPerson.id,
    )

    let item
    if (businessRole) {
        item = {
            resource: businessRole.resource,
            assignment: businessRole.assignment,
        }
    }

    const itemDetails = <BusinessRoleDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={assignmentId}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default BusinessRolesDrawer
